const MULTIPLE_SUCCESS_MESSAGES = [
  "Dobrze! Szukaj dalej 🔎",
  "Trafienie! To nie wszystko 🔎",
  "Poprawnie! Co jeszcze? 🔎",
  "Poprawny wybór. Wskaż kolejny element 🔎",
  "Wybrano poprawnie. Szukaj dalej 🔎",
  "Dobra odpowiedź. Pozostały kolejne 🔎",
  "Prawidłowo. Wskaż kolejny element 🔎",
];

const CORRECT_ANSWER_MESSAGES = [
  "✅ Właśnie tak!",
  "✅ Znakomicie!",
  "✅ Prawidłowa odpowiedź",
  "✅Odpowiedź jest właściwa",
];

const INCORRECT_ANSWER_MESSAGES = [
  "❌ Niestety błąd",
  "❌ Nie tym razem",
  "❌ Niepoprawnie",
  "❌ Błędna odpowiedź",
  "❌ Niewłaściwy wybór",
  "❌ Odpowiedź nieprawidłowa",
];

// Message history tracking - using WeakMap to avoid memory leaks
const messageHistory = new WeakMap<object, MessageHistory>();

interface MessageHistory {
  lastMultipleChoiceMessage: string | null;
  lastCorrectAnswerMessage: string | null;
  lastIncorrectAnswerMessage: string | null;
}

function getMessageHistory(instanceId: object): MessageHistory {
  if (!messageHistory.has(instanceId)) {
    messageHistory.set(instanceId, {
      lastMultipleChoiceMessage: null,
      lastCorrectAnswerMessage: null,
      lastIncorrectAnswerMessage: null,
    });
  }
  const history = messageHistory.get(instanceId);
  if (!history) {
    // This should never happen due to the check above, but TypeScript needs it
    return {
      lastMultipleChoiceMessage: null,
      lastCorrectAnswerMessage: null,
      lastIncorrectAnswerMessage: null,
    };
  }
  return history;
}

function getRandomMessage(
  messages: string[],
  lastMessage: string | null,
): string {
  if (messages.length === 0) return "";

  // If there's only one message, return it
  if (messages.length === 1) return messages[0];

  // If there's no last message, return a random one
  if (!lastMessage) {
    return messages[Math.floor(Math.random() * messages.length)];
  }

  // Filter out the last message to avoid repetition
  const availableMessages = messages.filter((msg) => msg !== lastMessage);

  // Return a random message from the available ones
  return availableMessages[
    Math.floor(Math.random() * availableMessages.length)
  ];
}

export function createMessageGenerator() {
  const instanceId = {};

  return {
    getRandomMultipleChoiceMessage: () => {
      const history = getMessageHistory(instanceId);
      const message = getRandomMessage(
        MULTIPLE_SUCCESS_MESSAGES,
        history.lastMultipleChoiceMessage,
      );
      history.lastMultipleChoiceMessage = message;
      return message;
    },
    getRandomCorrectAnswerMessage: () => {
      const history = getMessageHistory(instanceId);
      const message = getRandomMessage(
        CORRECT_ANSWER_MESSAGES,
        history.lastCorrectAnswerMessage,
      );
      history.lastCorrectAnswerMessage = message;
      return message;
    },
    getRandomIncorrectAnswerMessage: () => {
      const history = getMessageHistory(instanceId);
      const message = getRandomMessage(
        INCORRECT_ANSWER_MESSAGES,
        history.lastIncorrectAnswerMessage,
      );
      history.lastIncorrectAnswerMessage = message;
      return message;
    },
    reset: () => {
      const history = getMessageHistory(instanceId);
      history.lastMultipleChoiceMessage = null;
      history.lastCorrectAnswerMessage = null;
      history.lastIncorrectAnswerMessage = null;
    },
  };
}
